/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Retention_Logs_DescInputs */

const es_privacy_policy_retention_logs_desc = /** @type {(inputs: Privacy_Policy_Retention_Logs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retenidos 18 meses para seguridad y solucion de problemas, luego eliminados o anonimizados.`)
};

const en_privacy_policy_retention_logs_desc = /** @type {(inputs: Privacy_Policy_Retention_Logs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retained for 18 months for security and troubleshooting, then deleted or anonymized.`)
};

/**
* | output |
* | --- |
* | "Retained for 18 months for security and troubleshooting, then deleted or anonymized." |
*
* @param {Privacy_Policy_Retention_Logs_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_retention_logs_desc = /** @type {((inputs?: Privacy_Policy_Retention_Logs_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Retention_Logs_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_retention_logs_desc(inputs)
	return en_privacy_policy_retention_logs_desc(inputs)
});
export { privacy_policy_retention_logs_desc as "privacy_policy.retention.logs_desc" }